import get from 'lodash/get'

export default {
  data() {
    return {
      isShowShareIcon: true,
    }
  },
  methods: {
    shareTechCity() {
      if (!navigator.share) {
        this.isShowShareIcon = !this.isShowShareIcon
      } else if (get(this, '$refs[share-wrapper]')) {
        this.$refs['share-wrapper'].nativeShareClick()
      }
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/techCityShareHandler.js